// import { MenuItemIdGenerator } from "../../util/avantoeats/menuItemIdGenerator/MenuItemIdGenerator";
import { Product } from "./Product";
import { ShouldElementBeDisplayed } from "./ShouldElementBeDisplayed";
import { DisplayOptions } from "./DisplayOptions";
import { CurrentDateTimeInfo } from "./CurrentDateTimeInfo";
/**
 * Defines a category of the menu table, inside which will be stored many related products
 * For example: the "Burgers" category would have all the burger products of the restaurant (big mac, quarter pounder, mcchicken, etc)
 */
export class Category {
    static readonly ID_PREFIX = "cat";

    client:string;
	id: string;
    title: string;
    img:string;
    description:string;
    active: boolean;
    displayOrder: number;
    parentId:string;

    subCategories: Category[];
    products: Product[];

    displayOptions:DisplayOptions | null;

    //The following is NOT saved on AWS. We calculate it whenever we load data from the server and we know the server time.
    shouldDisplay:ShouldElementBeDisplayed | null;
    

    /**
     * Constructor
     * @param client PARTITION KEY: On the format "region.restaurantName". Unique identifier that tells us which restaurant this category belongs to
     * @param id SORT KEY: Unique identifier of this object on the database. Will be on the format "cat.XXXXXX", where XXXXX is the hexadecimal timestamp of when this category was created
     * @param title Category title (ex: Burgers)
     * @param img path to an image related to this category
     * @param description Description of the category (ex: All burgers come with extra fries and pop)
     * @param active Inactive categories won't be shown on the restaurant menu page
     * @param order Display order of this category (1 will be the first shown, 2 the second...)
     * @param parentId If this is a subcategory, the ID of the parent category should be defined here
     * @param subCategories SubCategories of this category (ex: Chicken burgers, angus burgers, kids burgers...)
     * @param products Products of this category (Ex: big mac, quarter pounder, etc)
     * @param displayOptions Options determining whether this category should be displayed for the customer or not
     * @param serverCurrentTime (OPTIONAL) If present, we use it to calculate whether this category should be displayed or not, 
     * based on it's display options. If not present, we assume that the category must always be displayed.
     */
	constructor(client:string, id:string, title:string, img:string, description:string, active:boolean, order:number, 
                parentId:string, subCategories:Category[], products:Product[], displayOptions:DisplayOptions | null, 
                serverCurrentTime?:CurrentDateTimeInfo) {

        this.client = client;
		this.id = id;
        this.title = title;
        this.img = img;
        this.description = description;
        this.active = active;
        this.displayOrder = order;
        this.parentId = parentId;
        this.subCategories = subCategories;
        this.products = products;
        this.displayOptions = displayOptions;

        if(serverCurrentTime!=null && displayOptions!=null){
            this.shouldDisplay = displayOptions.determineDisplayConditions(serverCurrentTime);
        }else{
            this.shouldDisplay = null;
        }

    }

    hasParent(){
        return this.parentId!=null && this.parentId!="";
    }
    
    // static createNew(client:string, parentCategoryId:string){
        // return new Category(
        //     client, MenuItemIdGenerator.generate(this.ID_PREFIX), "New Category", null,
        //     false, parentCategoryId, 0 , [], [],[]
        // );
    // }

    /** Converts this object into a format that can be saved on our database (DynamoDB) */
	// toAWSObject(){
        //Mandatory attributes
		// let categoryObj = {
		// 	"client" : this.client,
		// 	"id" : this.id,
		// 	"title" : this.title
		// } as any;
    // }

    /** Creates a cateogry object from the data pulled from AWS. Some attributes will be added later. */
    static newFromAWS(awsItem:any,serverDateTime?:CurrentDateTimeInfo){
        return new Category(
            awsItem.client,
            awsItem.id,
            awsItem.title,
            awsItem.img,
            awsItem.description,
            awsItem.active,
            awsItem.order,
            awsItem.parentId,
            //Both of these depend on other items of the table. They must be added later
            [], [],
            DisplayOptions.newFromAWS(awsItem.displayOptions),
            serverDateTime
        );
    }

    addProduct(p:Product){
        this.products.push(p);
    }
    addSubCategory(sub:Category){
        this.subCategories.push(sub);
    }
    /** Sorts the subcategories inside of the cateogry by their display order... */
    sortSubCategories(){
        this.subCategories.sort((a, b) => a.displayOrder < b.displayOrder ? -1 : a.displayOrder > b.displayOrder ? 1 : 0);
    }
    /** Sorts the products inside of the cateogry by their display order... */
    sortProducts(){
        this.products.sort((a, b) => a.displayOrder < b.displayOrder ? -1 : a.displayOrder > b.displayOrder ? 1 : 0);
    }

}